import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ComplianceOverview.Title',
    defaultMessage: 'Compliance Summary',
  },
  certificationType: {
    id: 'App.ComplianceOverview.CertificationType',
    defaultMessage: 'Certification Type',
  },
  certStatus: {
    id: 'App.ComplianceOverview.CertStatus',
    defaultMessage: 'Status',
  },
  propertyName: {
    id: 'App.ComplianceOverview.PropertyName',
    defaultMessage: 'Property',
  },
  unitNumber: {
    id: 'App.ComplianceOverview.UnitNumber',
    defaultMessage: 'Unit',
  },
  applicantName: {
    id: 'App.ComplianceOverview.ApplicantName',
    defaultMessage: 'Name',
  },
  complianceDocumentType: {
    id: 'App.ComplianceOverview.ComplianceDocumentType',
    defaultMessage: 'Compliance Document',
  },
  uploadDateTime: {
    id: 'App.ComplianceOverview.UploadDateTime',
    defaultMessage: 'Upload Date / Time',
  },
  isReviewed: {
    id: 'App.ComplianceOverview.IsReviewed',
    defaultMessage: 'Reviewed',
  },
  programType: {
    id: 'App.ComplianceOverview.ProgramType',
    defaultMessage: 'Program Type',
  },
  voucherEffectiveDate: {
    id: 'App.ComplianceOverview.VoucherEffectiveDate',
    defaultMessage: 'Effective Date',
  },
  certHistory: {
    id: 'App.ComplianceOverview.CertHistory',
    defaultMessage: 'Cert History',
  },
  complianceApprovalStatus: {
    id: 'App.ComplianceOverview.ComplianceApprovalStatus',
    defaultMessage: 'Compliance Approval Status',
  },
  isActive: {
    id: 'App.ComplianceOverview.IsActive',
    defaultMessage: 'Active',
  },
  isResident: {
    id: 'App.ComplianceOverview.IsResident',
    defaultMessage: 'Resident',
  },
  needsReview: {
    id: 'App.ComplianceOverview.NeedsReview',
    defaultMessage: 'Needs Review',
  },
  allOpenCerts: {
    id: 'App.ComplianceOverview.AllOpenCerts',
    defaultMessage: 'All Open Certs',
  },
  includeNotStartedCertifications: {
    id: 'App.ComplianceOverview.IncludeNotStartedCertifications',
    defaultMessage: 'Include Not Started Certifications',
  },
  attentionRequired: {
    id: 'App.ComplianceOverview.AttentionRequired',
    defaultMessage: 'Attention Required',
  },
  effectivePastDue: {
    id: 'App.ComplianceOverview.EffectivePastDue',
    defaultMessage: 'Effective Date Past Due',
  },
  certHistoryFor: {
    id: 'App.ComplianceOverview.CertHistoryFor',
    defaultMessage: 'Cert History for {name}',
  },
  certOpened: {
    id: 'App.ComplianceOverview.CertOpened',
    defaultMessage: 'Cert Opened',
  },
  firstSubmissionPacketUpload: {
    id: 'App.ComplianceOverview.FirstSubmissionPacketUpload',
    defaultMessage: '1st Submission Packet Upload',
  },
  daysInProcess: {
    id: 'App.ComplianceOverview.DaysInProcess',
    defaultMessage: 'Days in Process',
  },
  loadError: {
    id: 'App.ComplianceOverview.LoadError',
    defaultMessage: 'Something went wrong fetching the records.',
  },
  retry: {
    id: 'App.ComplianceOverview.Retry',
    defaultMessage: 'Retry',
  },
  pastDue: {
    id: 'App.ComplianceOverview.PastDue',
    defaultMessage: 'Past Due',
  },
  reviewOverdue: {
    id: 'App.ComplianceOverview.ReviewOverdue',
    defaultMessage: 'Review Overdue',
  },
  pastDueTooltip: {
    id: 'App.ComplianceOverview.PastDueTooltip',
    defaultMessage:
      "Past Due is determined by each property's settings and may vary per property and program. " +
      'Refer to the property settings for details.',
  },
  planningRangePastDue: {
    id: 'App.ComplianceOverview.PlanningRangePastDue',
    defaultMessage: 'Past Due',
  },
  planningRangeUnder30: {
    id: 'App.ComplianceOverview.PlanningRangeUnder30',
    defaultMessage: '0–30 Days',
  },
  planningRangeBetween31And60: {
    id: 'App.ComplianceOverview.PlanningRangeBetween31And60',
    defaultMessage: '31–60 Days',
  },
  planningRangeBetween61And90: {
    id: 'App.ComplianceOverview.PlanningRangeBetween61And90',
    defaultMessage: '61–90 Days',
  },
  planningRangeBetween90And120: {
    id: 'App.ComplianceOverview.PlanningRangeBetween90And120',
    defaultMessage: '91–120 Days',
  },
  planningRangeUpcoming: {
    id: 'App.ComplianceOverview.PlanningRangeUpcoming',
    defaultMessage: '120+ Days',
  },
  clearFilters: {
    id: 'App.ComplianceOverview.ClearFilters',
    defaultMessage: 'Clear filters ({count})',
  },
});

export default messages;
